var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notification-wrapper" }, [
    _vm.filteredNotifications.length > 0
      ? _c(
          "div",
          {
            class:
              "alert alert-dismissible fade in show alert-" +
              _vm.filteredNotifications[_vm.filteredNotifications.length - 1]
                .context,
            attrs: { role: "alert" }
          },
          [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close" },
                on: {
                  click: function($event) {
                    return _vm.closeAll()
                  }
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _vm.showErrorCode
              ? _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.filteredNotifications[
                        _vm.filteredNotifications.length - 1
                      ].code
                    )
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.filteredNotifications[
                    _vm.filteredNotifications.length - 1
                  ].message
                )
              }
            }),
            _vm._v(" "),
            _vm._l(
              _vm.filteredNotifications[_vm.filteredNotifications.length - 1]
                .stackTrace,
              function(trace, index) {
                return _c("p", { key: index, staticClass: "small" }, [
                  _vm._v(
                    "\n            " + _vm._s(trace.message) + "\n        "
                  )
                ])
              }
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }